export const setOfflineData = (key, data) => {
  if (data !== "" && data !== null && data !== undefined) {
    localStorage.setItem(`subway:${key}`, JSON.stringify(data));
  }
};

export const getOfflineData = (key) => {
  const data = localStorage.getItem(`subway:${key}`);
  if (data !== "" && data !== null && data !== undefined) {
    return JSON.parse(data);
  } else {
    return "";
  }
};

export const clearOfflineData = (key) => {
  localStorage.removeItem(`subway:${key}`);
};

export const clearTokenDataAndRedirectToLogin = (navigate) => {
  clearOfflineData("user");
  clearOfflineData("tokens");
  if (navigate) {
    navigate("/login");
    return;
  }
  window.location = window.location.origin + "/login";
};
